import { render } from "./HospitalsPlaceholder.vue?vue&type=template&id=72bb7588&scoped=true"
import script from "./HospitalsPlaceholder.vue?vue&type=script&lang=js"
export * from "./HospitalsPlaceholder.vue?vue&type=script&lang=js"

import "./HospitalsPlaceholder.vue?vue&type=style&index=0&id=72bb7588&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bb7588"]])

export default __exports__